import { ComponentProps, ReactNode } from 'react';

import { attachComponentData } from '@backstage/core-plugin-api';

import { FiltersProvider as FiltersProviderImpl } from '@spotify/confidence-core-react';

import { useOptionalPageBridgeProps } from '../../utils';
import { PAGE_WRAPPER_KEY } from '../composition';

export type PageFiltersProviderProps = Omit<
  ComponentProps<typeof FiltersProviderImpl>,
  'children' | 'storageKey'
> & { storageKey?: string };

const BridgedFiltersProvider = ({
  storageKey,
  children,
  ...rest
}: PageFiltersProviderProps & { children: ReactNode }) => {
  const bridgeProps = useOptionalPageBridgeProps();
  const resolvedStorageKey = storageKey ?? bridgeProps?.descriptor.id ?? '';

  return (
    <FiltersProviderImpl storageKey={resolvedStorageKey} {...rest}>
      {children}
    </FiltersProviderImpl>
  );
};

export const FiltersProvider = (_props: PageFiltersProviderProps): null => null;

attachComponentData(FiltersProvider, PAGE_WRAPPER_KEY, BridgedFiltersProvider);
